import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../../AgentForm.module.scss';
import { InfoIcon } from '@navi/web-ui/lib/icons';
import { IWarningSectionProps } from '../../interfaces/types';

const WarningSection = (props: IWarningSectionProps) => {
  const { message, showTriangle = true, color, iconColor, bgColor } = props;
  return (
    <div className={styles.warningBox} style={{ backgroundColor: bgColor }}>
      {showTriangle && <div className={styles.triangle}></div>}
      <Typography variant={'h4'} color={color} className="flex">
        <div>
          <InfoIcon color={iconColor} className="pr-1 pt-0.5" />
        </div>
        {message}
      </Typography>
    </div>
  );
};

export default WarningSection;
